import styled from 'styled-components';
import { colors } from '@/constants';
import VideoScanner from './VideoScanner';
import { useEffect, useState } from 'react';
import { MdOutlinePhotoCamera } from 'react-icons/md';

declare global {
  interface Window {
    BarcodeDetector: any;
  }
}

const Button = styled.button`
  padding: 0px;
  border: none;
  display: grid;
  place-items: center;
  grid-auto-flow: column;
  background-color: ${colors.transparent};
`;

const OutlinePhotoCamera = styled(MdOutlinePhotoCamera)`
  color: ${colors.gray.gray60};
`;

interface Props {
  handleClick?: () => void;
  handleFilter: (value: string) => void;
}

const BarcodeScanner = ({ handleFilter, handleClick }: Props) => {
  const [isSupported, setIsSupported] = useState<boolean>(true);
  const [isOpenedCamera, setIsOpenedCamera] = useState(false);

  const openCamera = () => setIsOpenedCamera(true);
  const closeCamera = () => setIsOpenedCamera(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (isOpenedCamera) closeCamera();
    }, 9000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    const startScanner = async () => {
      if (!('BarcodeDetector' in window)) {
        setIsSupported(false);
        return;
      }
    };

    startScanner();
  }, []);

  return (isSupported &&
    <>
      <Button onClick={handleClick ? handleClick : openCamera}>
        <OutlinePhotoCamera size={20} color={colors.gray.gray60}/>
      </Button>

      {isOpenedCamera && 
        <VideoScanner 
          closeCamera={closeCamera} 
          handleFilter={handleFilter} 
        />
      }
    </>
  );
};

export default BarcodeScanner;
